import SimpleRatingBadge from '@risksmart-app/components/src/simple-rating-badge/SimpleRatingBadge';
import { colours } from '@risksmart-app/components/src/utils/colours';
import type { FC } from 'react';

import styles from './style.module.scss';

export interface BadgeListProps {
  badges: string[];
  color?: string;
  /**
   * Wrap as a flex row. Flex line breaking ignores the `white-space: nowrap` a
   * Cloudscape cell imposes when "Wrap lines" is off, which clipped CUS-384.
   */
  isWrapped?: boolean;
}

const BadgeList: FC<BadgeListProps> = ({
  badges = [],
  color,
  isWrapped = false,
}) => {
  return badges.length ? (
    <div
      data-testid={'badgeList'}
      className={isWrapped ? styles.badgeListWrapped : styles.badgeList}
    >
      {[...badges]
        ?.sort((a, b) => a.localeCompare(b))
        .map((badge, i) => (
          <SimpleRatingBadge
            key={i + badge}
            rating={{
              color: color ?? colours['charts-grey-450'].backgroundColor,
              label: badge || '',
              tooltip: badge || undefined,
            }}
          >
            {badge}
          </SimpleRatingBadge>
        ))}
    </div>
  ) : null;
};

export default BadgeList;
